module.exports = __webpack_public_path__ + "img/8.bd2777b4.jpg";